module.exports = ".pending-invite-modal-container{\n  display:block;\n  border-radius: 25px\n}\n.pending-invite-modal-text{\n  color: rgba(125, 131, 133, 1.0);\n  font-size: 20px;\n  text-align:center;\n}\n.pending-invite-modal-close{\n  text-align:center;\n}\n.pending-invite-modal-close button{\n  font-size: 20px;\n  width: 75px;\n  height: 50px;\n  border: 3px;\n  color: rgba(255, 20, 30, 1.0);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pending-invite-reminder/pending-invite-reminder.component.css
// module id = ./src/app/pending-invite-reminder/pending-invite-reminder.component.css
// module chunks = main